import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from '@/api/notifications.api';
import type { ListQueryParams } from '@/types/api';

const KEY = 'notifications';

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: [KEY, 'unread-count'],
    queryFn: () => notificationsApi.unreadCount(),
    refetchInterval: 60_000,
  });
}

export function useNotificationsList(params: ListQueryParams) {
  return useQuery({
    queryKey: [KEY, 'list', params],
    queryFn: () => notificationsApi.list(params),
    placeholderData: (prev) => prev,
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.markRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useSendNotification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.send,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [KEY] }),
  });
}
